// PARAQTA — login modal + devLogin + guest mode.

import { setIsGuest } from '../../core/state.js';
import { show } from '../../core/router.js';
import { toast } from '../../utils/toast.js';
import { busyStart, busyEnd } from '../../core/ui-queue.js';

export function showLoginModal() {
  document.getElementById('loginModal').classList.add('open');
  // Адамның өз әрекеті — бірден ашылады, бірақ ашық тұрғанда үстіне
  // басқа оверлей (PWA т.б.) шықпайды.
  try { busyStart('login'); } catch (_) {}
}

export function closeLoginModal() {
  document.getElementById('loginModal').classList.remove('open');
  try { busyEnd('login'); } catch (_) {}
}

// Dev environment hostname check: localhost немесе RFC 1918 private LAN
// (192.168.X.X / 10.X.X.X / 172.16-31.X.X). Production domain (paraqta.kz)
// бұл pattern-ге сай емес — devLogin өшіріледі.
function isDevHost(host) {
  return host === 'localhost'
      || host === '127.0.0.1'
      || /^192\.168\./.test(host)
      || /^10\./.test(host)
      || /^172\.(1[6-9]|2\d|3[0-1])\./.test(host);
}

export function devLogin() {
  if (!isDevHost(location.hostname)) {
    toast('Dev кіру тек dev environment-те қолжетімді');
    return;
  }
  const id = document.getElementById('devTgId').value.trim();
  if (!id) {
    toast('Telegram ID енгізіңіз');
    return;
  }
  window.location.href = '/api/auth/dev-login/' + id;
}

export function enterGuest() {
  setIsGuest(true);
  // Step LH1: body.guest-mode класы CSS-те Top Nav search/tabs/user
  // info + Mobile bottom nav-ты жасырады. JS-тен per-element style
  // өзгерту керек emес — login кейін loginDone() classList.remove
  // арқылы қалпына келтіреді.
  document.body.classList.add('app-mode');
  document.body.classList.add('guest-mode');
  document.getElementById('landingPage').style.display = 'none';
  document.getElementById('app').style.display = 'block';
  document.getElementById('navGuestLogin').style.display = 'inline-block';
  const cta = document.getElementById('guestCTA');
  if (cta) cta.style.display = 'block';

  show('catalog');
}
